var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.557 8.5a6.67 6.67 0 01-6.666 6.667c-3.68 0-5.927-3.707-5.927-3.707m0 0h3.013m-3.013 0v3.333M1.224 8.5c0-3.68 2.96-6.667 6.667-6.667 4.446 0 6.666 3.707 6.666 3.707m0 0V2.207m0 3.333h-2.96",
    stroke: "#ED1B2E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgVector;